/*

----- Video Player ----- 
Essentially a wrapper for third-party API's such as the youtube iframe embedded player, this could be extended to support other services such as Vimeo.
*/

import { component as axisYoutubePlayer } from "./axis-youtube-player";

var instances = {};

function getInstanceId(context) {
    if (!context) {
        AXISDebug.output(3,"Video Player: No context provided");
        return false;
    }
    let id = context.attr(expressSelectors()['axis-video-player']['initialise']);
    if (!id) {
        AXISDebug.output(3,"Video Player: No Id found, has this element been initialised?");
        return false;
    } else {
        return id;
    }
}

function setContext(id, value) {
    return instances[id]['context'] = value;
}

function getContext(id) {
    return instances[id]['context'];
}

function setUrl(id, value) {
    return instances[id]['url'] = value;
}

function getUrl(id) {
    return instances[id]['url'];
}

function setDurationContainer(id, value) {
    return instances[id]['duration-container'] = value;
}

function getDurationContainer(id) {
    return instances[id]['duration-container'];
}

function setProvider(id, value) {
    return instances[id]['provider'] = value;
}

function getProvider(id) {
    return instances[id]['provider'];
}

function setApi(id, value) {
    return instances[id]['player'] = value;
}

function getApi(id) {
    return instances[id]['player'];
}


function initialise(context, config = {}) {    
    if (AXISDebug.level() >= 3) {
        AXISDebug.output("Video Player: Initialising Video player", context);
    }
    // Get instance id.
    let id = context.attr(expressSelectors()['axis-video-player']['initialise']);
    // If no Id then generate one.
    if (!id) {
        context.attr(expressSelectors()['axis-video-player']['initialise'], generateId());
        id = context.attr(expressSelectors()['axis-video-player']['initialise']);
        instances[id] = {};
        // Update instance.
        setContext(id, context);
    } else {
        return instances[id];
    }

    // Get url.
    let url = context.attr(expressSelectors()['axis-video-player']['url']);

    if (!url) {
        // Fallback for lightbox.
        url = context.attr(expressSelectors()['axis-youtube-player']['url']);
        if (!url) {
            console.error("Video Player: No Url provided");
            return false;
        }
    }

    // Update instance.
    setUrl(id, url);
    // Should we display duraction?
    let durationContainer = context.find('[' + expressSelectors()['axis-video-player']['duration'] + ']');
    // Update instance.
    setDurationContainer(id, durationContainer);
    // Establish Provider.
    let serviceProvider = detectServiceProvider(id);
    // Update instance.
    setProvider(id ,serviceProvider);
    // Initialise player.
    return initialisePlayer(id);
}

// Detect service provider ( i.e Youtube or Vimeo )
function detectServiceProvider(id) {
    // Get Url.
    let url = getUrl (id);
    // Provider.
    let providor = undefined;
    // Create regexp.
    let youtubeRegexp = new RegExp("^https:\/\/www\.youtube\.com\/.*");
    if (youtubeRegexp.test(url)) {
        providor = "youtube";
    }
    return providor;
}

// Initialise player.
function initialisePlayer(id) {
    // Get service provider.
    let provider = getProvider(id);
    // Get URL.
    let url = getUrl(id);
    if (!url) {
        AXISDebug.output(3,"Video Player: Please provide a URL", id);
        return false;
    }
    let context = getContext(id);
    if (provider) {
        if (provider == "youtube") {
            let player = axisYoutubePlayer.initialise(context);
            setApi(id, player);
            // Pass back player.
            return(player);
        } else {
            AXISDebug.output(3,"Video Player: Sorry we don't support that service providor " + provider);
            return false;
        }
    } else {
        AXISDebug.output(3,"Video Player: Cannot initialise player without specifying a providor for instance" + id);
        return false;
    }

}

function stopPlayer(id) {
    let provider = getProvider(id);
    let context = getContext(id);
    switch(provider) {
        case "youtube": 
            return axisYoutubePlayer.stopVideo(context);
        default:
            AXISDebug.output(3,"Video Player: We dont support that provider", id);
            return false;
    }
}

function startPlayer(id) {
    let provider = getProvider(id);
    let context = getContext(id);
    switch(provider) {
        case "youtube":
            return axisYoutubePlayer.playVideo(context);
        default:
            AXISDebug.output(3,"Video Player: Cannot resume video for that provider", id);
            return false;
    }
}

function pausePlayer(id) {
    let provider = getProvider(id);
    let context = getContext(id);
    switch(provider) {
        case "youtube":
            return axisYoutubePlayer.pauseVideo(context);
        default:
            AXISDebug.output(3,"Video Player: Cannot pause video for that provider", id);
            return false;
    }
}

// Return the status of the player e.g whether it is in que, player or paused.
function playerState(id) {
    let provider = getProvider(id);
    let context = getContext(id);
    switch(provider) {
        case "youtube":
            return axisYoutubePlayer.getState(context);
        default:
            AXISDebug.output(3,"Video Player: Cannot get video state for that provider", id);
            return false;
    }    
}

function destroy(id) {
    let provider = getProvider(id);
    let context = getContext(id);
    switch(provider) {
        case "youtube":
            axisYoutubePlayer.destroy(context);
            delete instances[id];
            return true;
        default:
           AXISDebug.output(3,"Video Player: Cannot destroy for that provider", id);
            return false;
    }
}

var component = $.component = {
    initialise: (context, config) => {
        return initialise(context, config);
    },
    getPlayer: (context) => {
        let id = getInstanceId(context);
        return getPlayer(id);
    },
    startPlayer: (context) => {
        let id = getInstanceId(context);
        return startPlayer(id);
    },
    pausePlayer: (context) => {
        let id = getInstanceId(context);
        return pausePlayer(id);
    },
    stopPlayer: (context) => {
        let id = getInstanceId(context);
        return stopPlayer(id);
    },
    getPlayerState: (context) => {
        let id = getInstanceId(context);
        return playerState(id);
    },
    destroy: (context) => {
        let id = getInstanceId(context);
        return destroy(id);
    }
}
 
export { component };